import {Component, NgZone, ViewChild} from '@angular/core';
import {Content, Keyboard, NavController, NavParams, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {CONFIG} from "../../../app/config";

import {DataService} from "../../../providers/data-service";
import {AFTER_LOGIN} from "../../../app/import";
import {NavRepository} from "../../../repositories/nav-repository";
import {TAction, TContatoTipo, TDevicerScan, TLoginTipo} from "../../../app/enum";
import {NetworkInterface} from "@ionic-native/network-interface";

import {MessageService} from "../../../providers/message-service";
import {LogadoService} from "../../../providers/logado-service";

import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {HotspotWorkPage} from '../hotspot-work/hotspot-work';
import {RegeditMenuPage} from '../regedit-menu/regedit-menu';
import {ProfileService} from '../../../providers/profile-service';
import {LoadingErroPage} from '../loading-erro/loading-erro';
import {MachineMenuPage} from '../machine-menu/machine-menu';

@Component({
    selector: 'page-profile-auth',
    templateUrl: 'profile-auth.html',
    providers: [ProfileService]
})
export class ProfileAuthPage {

    @ViewChild(Content) content: Content;

    droped: boolean;
    dropedStart: boolean;

    justLogin: boolean;
    rootile: any;
    redeemcode: string;

    btBackEffect: boolean;

    config: any;

    TLoginTipo: any = TLoginTipo;
    loginTipo: TLoginTipo;
    
    documento: string = '';
    password: string = '';
    passcopy: string = '';
    contato: any;
    
    tecladoText: string = '';

    etapa: number;
    versao: string;

    detail: boolean;
    ipreal: string;
    ipwifi: string;

    supportStep: number = 0;
    
    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    requestIpad: boolean;
    devicerKtoy = (CONFIG.data.device.DevicerNome == 'K2' || CONFIG.data.device.DevicerNome == 'K2_MINI');

    constructor(public navCtrl: NavController, public viewCtrl: ViewController,
                public dataService: DataService,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public networkInterface: NetworkInterface,
                public params: NavParams,
                public navParams: NavParams, public navRepository: NavRepository,
                public util: Util, public messageService: MessageService, public keyboard: Keyboard,
                private ngZone: NgZone) {

        this.config = CONFIG;

        this.redeemcode = this.dataService.get('param.redeemcode');

        this.justLogin = this.navParams.get('justLogin');
        this.rootile = this.navParams.get('rootile');
        
        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));

        //#IPAD-BARMAN-CHECKIN
        this.requestIpad = this.util.anyParams(false, this.navParams.get('requestIpad'));
        
        this.loginTipo = this.util.anyParams(TLoginTipo.loStarting, this.navParams.get('loginTipo'));
        this.droped = (this.loginTipo > TLoginTipo.loStarting);

        /* TECTOY - Apaga Ledisplay */
        if (this.devicerKtoy && !this.droped) this.util.machineHard('desligarLedStatus', '').subscribe();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Auth', '/login-profile/register');

        this.prepareOpen();

    }

    controlK() {

        (window as any).handappMainInstance.setDevelop('Ctrl+K', null);

    }

    ionViewDidLoad() {

        document.title = 'OLHA seu rolê, sem fila!';
        this.util.statusBarColor(this.config.data.brandap ? TStatusBar.sbStyleDefault : TStatusBar.sbStyleLightContent);

    }

    ionViewDidEnter() {

        //noinspection JSUnusedGlobalSymbols

        //this.util.statusBarColor
        //NAO colocar nesse evento quando for push
        //evento acontece quando ja terminou a transicao
        //Modal, tem que ser nesse evento, pois a janela sobe
        //e quando esta subindo fica "branco" até completar a
        //transicao de subir a tela.

    }

    ionViewWillEnter() {

        this.akkjson = (window as any).handappMainInstance.appjson;
        this.monitorAuth = this.akkjson.hotwork;
    
    }

    supportWork() {
    
    }

    cleanerText() {

        this.documento = '';
        this.password = '';
        this.passcopy = '';
        this.tecladoText = '';

    }

    passwordText() {

        let bool = (this.loginTipo == TLoginTipo.loRegister);
        
        if (bool && this.password && this.tecladoText.length < 8)
        return ['C','O','N','F','I','R','M','E'];
        return ['S','U','A','S','E','N','H','A'];

    }

    prepareOpen() {

        if (this.etapa == 0) {

            //this.keyboard.disableScroll(true);
            this.subscribeFacebookExpired();

            //KeyboardWillShow - Nao utilizado Keyboard.isOpen() pois troca seco o HTML
            window.addEventListener('keyboardWillShow', (event) => {
                this.ngZone.run(() => {
                    this.util.isKeyboard = true;
                });
            });

            //KeyboardDidHide - Nao utilizado Keyboard.isOpen() pois troca seco o HTML
            window.addEventListener('keyboardDidHide', () => {
                this.ngZone.run(() => {
                    this.util.isKeyboard = false;
                });
            });

        }

    }

    networkInfo() {

        //APP-PUBLISH - Nao esta funcionando pois o login-register esta por cima na tela do label da versao.
        this.util.vibrate(50);

        this.detail = !this.detail;
        if (!this.detail) return;

        this.util.realConnection().subscribe(
            data => this.ipreal = data.query,
            erro => this.ipreal = '');

        if (!this.util.nativeApp()) return;

        // IPReal - Native
        // this.networkInterface.getCarrierIPAddress()
        //     .then(data => console.info(`IP: ${data.ip}, Subnet: ${data.subnet}`))
        //     .catch(erro => console.error(`Unable to get IP: ${erro}`));

        this.networkInterface.getWiFiIPAddress()
            .then(data => this.ipwifi = data.ip)
            .catch(erro => this.ipwifi = '');

    }

    profileOito() {

        if (!this.redeemcode) {

            //ProfileOito
            let loading = this.util.loadingDots('Redefinindo Senha...');
            loading.present();

            this.profileService.profile(TAction.acCode, this.rootile.Profile.ProfileID, null, '&ProfileRnid=' + this.rootile.Profile.ProfileRnid + '&ProfileOito=' + this.password)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => this.dismiss(),
                    erro => this.util.alertResult(erro)
                );

        }

        if (this.redeemcode) {

            //ProfileOito
            let loading = this.util.loadingDots('Redefinindo Senha...');
            loading.present();

            this.logadoService.started(TAction.acDeem, null, '&RedeemCode=' + this.redeemcode + '&ProfileOito=' + this.password)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        let object = {etapa: 1, action: null, titulo: 'Senha Alterada', result: 'Acesse sua conta pelo app'};
                        this.navCtrl.setRoot(LoadingErroPage, object);

                    },
                    erro => {

                        this.util.alertResult(erro);

                    });

        }

    }

    profileInit() {

        // Password Verify
        if (!this.password || this.password.length != 8) {
            this.util.toastSimply('Senha de 8 digitos');
            return;
        }


        // Passcopy Verify
        if (this.loginTipo == TLoginTipo.loRegister && (!this.passcopy || this.passcopy.length != 8)) {
            this.util.toastSimply('Repetição de 8 digitos');
            return;
        }


        // Password Verify
        if (this.loginTipo == TLoginTipo.loRegister && this.password != this.passcopy) {
            this.util.alertSimply('Senha e repetição diferentes.');
            return;
        }

        if (this.justLogin && !this.monitorAuth) {
            this.profileOito();
            return;
        }


        //Started Auth
        let proauth = {
            ProfileAuth: (this.loginTipo != TLoginTipo.loRegister),
            ProfileRnid: (this.loginTipo == TLoginTipo.loFacebook ? '' : this.documento),
            ProfileOito: (this.loginTipo == TLoginTipo.loFacebook ? '' : this.password),
            Facebook:    (this.loginTipo == TLoginTipo.loFacebook ? this.contato : null),
        };


        //#MonitorAuth - Login diretona rede local
        if (this.monitorAuth) {
            this.cleanerText();
            this.usuarioAuth(proauth);
            return;
        }


        // Procria || Proauth
        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acAuth, {Proauth: proauth})
            .finally(() => loading.dismiss())
            .subscribe(data => {

                if (data.Action == '#STARTING#') {
                    //let titulo = (this.passcopy == '' ? 'CONTA NÃO EXISTENTE' : 'CONTA EXISTENTE');
                    //let alerta = (this.passcopy == '' ? 'Crie uma conta nova, vamos direcionar você.' : 'Já existe uma conta para o CPF, vamos direcionar você.');
                    //this.util.alertSimply(alerta, titulo, 'Continuar', false, null, () => this.desdropar());

                    let onReload = () => {

                        if (this.passcopy == '') {
                            this.loginTipo = TLoginTipo.loRegister;
                            this.content.resize();
                        }

                        if (this.passcopy != '') {
                            this.loginTipo = TLoginTipo.loPassword;
                            this.passcopy = '';
                            this.content.resize();
                            setTimeout(() => this.profileInit(), 500);
                        }

                    };

                    let titulo = (this.passcopy == '' ? 'CONTA NÃO EXISTENTE' : 'CONTA EXISTENTE');
                    let alerta = (this.passcopy == '' ? 'Repita a senha e crie uma conta. Estamos esperando você :)' : 'Já existe uma conta para o CPF, vamos direcionar você e tentar fazer o login com a senha informada.');
                    this.util.alertSimply(alerta, titulo, 'Continuar', false, null, () => onReload());

                }

                else if (data.Action == '#DOCUMENT#') {
                    this.dropar(TLoginTipo.loDocument);
                }

                else if (data.Action == '#FACENOVO#') {
                    this.dropar(TLoginTipo.loRegister);
                }

                else if (data.Action == '#FACEAUTH#') {
                    this.dropar(TLoginTipo.loPassword);
                }

                else if (data.Action == '#REGISTER#') {
                    this.dropar(TLoginTipo.loRegister);
                    this.profileNovo(data);
                }

                else if (data.Sessao) {
                    this.util.statusBarColor(TStatusBar.sbStyleDefault);
                    if (!this.viewCtrl.isOverlay) this.navRepository.afterLogin(this.navCtrl, AFTER_LOGIN).subscribe();
                    if (this.viewCtrl.isOverlay) this.dismiss({}); //#GAMBI - envia um objeto para retornar HotspotPage - Login
                }

                else {
                    this.util.alertSimply('Ação inválida do servidor.');
                }

            }, erro => {

                this.util.alertResult(erro, () => this.password = '');

            });

    }

    profileNovo(data) {

        if (this.password.length != 8 || this.passcopy.length != 8) {

            this.util.alertSimply('Informe sua senha para criar a conta.', 'Sua Senha');
            return;

        }

        //APP-PUBLISH - Vivian testando disse que não estava abrindo a janela android veio.
        this.ngZone.run(() => {

            if (!data.Contatos) data.Contatos = [];
            if (!data.Addresss) data.Addresss = [];
            if (!data.Accounts) data.Accounts = [];

            let contato = data.Contatos.find(contato => contato.ContatoRede == TContatoTipo.coFace);
            if (!contato && this.contato) data.Contatos.push(this.contato);
            if (contato) {
                contato.ContatoFoto = this.contato.ContatoFoto;
                contato.ContatoMini = this.contato.ContatoMini;
                contato.ContatoLock = this.contato.ContatoLock;
            }

            let object = {rootile: data};
            
            // this.navCtrl.push(ProfileMenuPage, object).then(() => {
            //     if (!this.viewCtrl.isOverlay) this.desdropar();
            //     if ( this.viewCtrl.isOverlay) this.dismiss(null);
            // });

            let onDone = (data) => {
                //if (!this.viewCtrl.isOverlay) this.desdropar();
                if ( this.viewCtrl.isOverlay) this.dismiss(null);
            };            
            this.util.modalopen(ProfileMenuPage, 'alto', false, object, null, null, onDone).subscribe();

        });

    }

    esqueciOito() {

        if (this.documento.length != 14) {
            let alerta = 'Preencha o CPF para continuar.';
            this.util.alertSimply(alerta);
            return;
        }


        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acLost, null, '&ProfileRnid=' + this.documento)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.alertSimply('Senha enviada para seu e-mail.', 'Pronto!'),
                erro => this.util.alertResult(erro)
            );

    }

    tecladoOkey(btn) {
        
        let validado = this.util.validaCNPF(this.documento);

        if (btn == 'ok') {

            if (!validado && !this.documento) {
                this.documento = this.util.formatDOC(this.tecladoText);
                this.tecladoText = '';
            }
            else if (validado && !this.password && this.tecladoText.length == 8) {
                this.password = this.tecladoText;
                this.tecladoText = '';
                if (this.loginTipo == TLoginTipo.loPassword) this.profileInit();
            }
            else if (validado && this.password && this.tecladoText.length == 8) {
                this.passcopy = this.tecladoText;
                this.profileInit();
            }

        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            if (this.passcopy && this.passcopy == this.tecladoText) this.tecladoText = '';
            else if (this.tecladoText.length) this.tecladoText = this.tecladoText.substring(0, this.tecladoText.length-1);
            else if (!this.tecladoText.length && this.password) this.password = '';

            if (this.tecladoText[this.tecladoText.length-1] == '.' || this.tecladoText[this.tecladoText.length-1] == '-') this.tecladoText = this.tecladoText.substring(0, this.tecladoText.length-1);
        }

        else if (btn == 'left-thin') {
            if (this.tecladoText.length) this.tecladoText = this.tecladoText.substring(0, this.tecladoText.length-1);
        }

        else if (btn == 'dot') {
            //this.tecladoText = this.tecladoText + '.';
        }

        else {
            let dot = (this.tecladoText.length == 3 || this.tecladoText.length == 7)
            let tra = (this.tecladoText.length == 11)
            if (!validado && this.tecladoText.length < 14) this.tecladoText = this.tecladoText + (dot ? '.' : (tra ? '-' : '')) + btn;
            else if (validado && this.tecladoText.length < 8) this.tecladoText = this.tecladoText + btn;
        }

    }


    dropar(loginTipo: TLoginTipo) {


        //Totem-K2
        if (loginTipo == TLoginTipo.loPassword && this.monitorAuth && this.devicerKtoy) {
            let object = {};
            this.navCtrl.push(MachineMenuPage, object, {animate: false}).then(() => this.desdropar());
            return;
        }

        this.dropedStart = true;

        this.loginTipo = loginTipo;

        switch (loginTipo) {

            case TLoginTipo.loStarting:
                return;
                
            case TLoginTipo.loRegister:
                /* Google Analytics */
                this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Init', '/login-profile/cadastro');
                break;

            case TLoginTipo.loPassword:
                /* Google Analytics */
                this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Oito', '/login-profile/password');
                break;

            case TLoginTipo.loFacebook:
                this.facebook();
                return;

            case TLoginTipo.loDocument:
                this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Auth', '/login-profile/document');
                break;

        }


        this.ngZone.run(() => {

            this.droped = true;
            setTimeout(() => this.btBackEffect = true, 900);

        });

        this.util.statusBarColor(this.config.data.brandap ? TStatusBar.sbStyleDefault : TStatusBar.sbStyleLightContent);

    }

    desdropar() {

        if (this.viewCtrl.isOverlay && (!this.droped || this.justLogin)) {
            this.dismiss();
            return;
        }

        this.ngZone.run(() => {

            this.droped = false;
            this.btBackEffect = false;

        });

        this.password = '';
        this.passcopy = '';
        this.contato = null;

        this.util.statusBarColor(this.config.data.brandap ? TStatusBar.sbStyleDefault : TStatusBar.sbStyleLightContent);

    }

    onKeydown(event) {

        /**                                 //Ctrl+V "V"             //Ctrl+V "CTRL"   **/
        return (event.keyCode == 16) || (event.keyCode == 17) || (event.keyCode == 86) || (event.keyCode == 9) || (event.keyCode == 8) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105);

    }

    facebook() {

        let onFace = (data) => {

            this.contato = data.contato;
            this.profileInit();

        };

        this.logadoService.facebook().subscribe(
            (data) => onFace(data),
            (erro) => this.util.alertResult(erro));

    }

    subscribeFacebookExpired() {

        this.messageService.get('facebook.expired')
            .subscribe(data => {

                let alerta = 'Seu token expirou, deseja continuar?';
                this.util.alertQuestion('Facebook', alerta, 'Confirmar', () => this.dropar(TLoginTipo.loFacebook), false, true);

            });

    }






    handappInit() {

        //#MonitorAuth - Login diretona rede local
        if (this.monitorAuth) return;

        //else
        (window as any).handappMainInstance.handappInit();

    }

    handappRoot() {

        this.logadoService.logout();

        let object = {etapa: 0, loginTipo: TLoginTipo.loStarting};
        this.navCtrl.setRoot(ProfileAuthPage, object);

    }

    regeditMenu() {

        //#MonitorAuth - Login diretona rede local (GRAVA)
        let onLoad = () => this.monitorAuth = this.akkjson.hotwork;
        let object = {};
        this.util.modalopen(RegeditMenuPage, 'alto', false, object, null, null, onLoad).subscribe();

    }

    usuarioAuth(proauth) {

        //STARTED - Carrega o Hotspot do Monitor
        if (!this.akkjson.hotwork) return;

        //#MonitorAuth - Login diretona rede local
        let onData = (data) => {

            //#LOGADO
            let profile = this.util.deepCopy(data.Usuarios[0].Profile);
            let rootile = {Sessao: data.Sessao, Profile: profile};
            this.logadoService.profileJson(TAction.acAuth, rootile);

            //
            this.akkjson.hotwork.Usuarios = data.Usuarios;
            
            //#IPAD-CHECKIN-PAYBOOK-BARMAN
            if (this.requestIpad || this.devicerKtoy) {
                this.dismiss(data.Usuarios[0]);
                return;
            }

            //Checkin pelo usuario volta escutar Workday!
            this.util.websterOpen = true;
            (window as any).handappMainInstance.escutarTela(TDevicerScan.dsWorkday);

            let object = {flagstor: true, etapa: 0, rootile: rootile, meritums: null};
            this.navCtrl.push(HotspotWorkPage, object).then(() => this.desdropar());
        
        }

        // Procria || Proauth
        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(true, 'DESK-Started', 0, '', TAction.acAuth, {Proauth: proauth})
        .finally(() => loading.dismiss())
        .subscribe(
            data => onData(data),
            erro => this.util.alertResult(erro, () => this.password = ''));

    }



    dismiss(result: any = null) {

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss(result);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-auth/profile-auth.ts